<template>
  <v-dialog v-model="dialog" max-width="800px" scrollable persistent>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <add-button v-if="!id"></add-button>
        <edit-icon-button v-else></edit-icon-button>
      </div>
    </template>
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text class="pt-2">
        <v-form ref="form" v-model="isValid" class="sms-form">
          <label>Template ID</label>
          <v-text-field
            :rules="rules"
            type="number"
            outlined
            dense
            v-model="form._id"
          ></v-text-field>
          <label>Template Title</label>
          <v-text-field
          :rules="rules"
          type="text"
          outlined
          dense
          v-model="form.title"
          ></v-text-field>
          <div class="chat__media mb-4" v-if="media">
            <v-btn  icon color="red" @click="media = null">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <img :src="media" />
          </div>
          <div>
            <label>Upload Image</label>
            <v-btn icon @click="$refs.input.click()" :color="media ? 'green' : ''">
              <v-icon> mdi-image </v-icon>
            </v-btn>
            <input type="file" @change="onFileChange" accept="image/*" ref="input" />
          </div>
          <div class="mt-3">
            <label>Template Text</label>
            <editor ref="editor" v-model="form.text"></editor>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="pr-5">
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
        <v-btn v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher" text color="green" @click="submit()">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getDate, resizeFile } from "../../assets/js/common";
import { auth, smsTemplates } from "../../assets/js/firebase";
import AddButton from "../buttons/AddButton.vue";
import EditIconButton from "../buttons/EditIconButton.vue";
import Editor from "../templates/create/Editor.vue";
export default {
  components: { AddButton, EditIconButton, Editor },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        text: "",
        _id: "",
        title: "",
      },
      rules: [(v) => !!v || "Field is required."],
      isValid: false,
      dialog: false,
      media: "",
    };
  },
  computed: {
    id() {
      return this.item.id;
    },
    title() {
      return this.id ? "Update SMS Template" : "Create SMS Template";
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        Object.keys(this.form).forEach((key) => {
          if (this.item[key] != undefined) this.form[key] = this.item[key];
        });
        if(this.item['media'])
          this.media = this.item['media']
      }
      this.$nextTick(() => {
        this.$refs.editor.initFormula(this.form.text);
      });
    },
  },
  methods: {
    async submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let text = vm.form.text;
      if (text == "") return vm.$root.alert("Template text is requird");
      let updated_by = auth.currentUser.email;
      console.log('vm.form', vm.form)
      let doc = { ...vm.form, updated_at: getDate(), updated_by, media:vm.media };
      try {
        vm.$loader.show();
        let snap = await smsTemplates
          .where("_id", "==", vm.form._id)
          .limit(1)
          .get();
        if (snap.size > 0 && (!vm.id || vm.id != snap.docs[0].id)) {
          vm.$loader.hide();
          vm.$alert.show(
            "Another sms template already exists with same id. Please enter a unique id."
          );
          return;
        }
        if (vm.id) {
          await smsTemplates.doc(vm.id).update(doc);
        } else {
          await smsTemplates.add({ ...doc, created_at: getDate() });
        }
        vm.dialog = false;
        vm.$loader.hide();
        this.$refs.editor.initFormula("");
        vm.form = { _id: "", text: "", title: "", };
        vm.media = null;
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    async onFileChange() {
      const vm = this;
      vm.media = null;
      let files = vm.$refs.input.files;
      if (files[0]) {
        vm.media = await resizeFile(files[0]);
      }
    },
  },
};
</script>

<style lang="scss">
.sms-form {
  input[type=file] {
    display: none;
  }
}

.chat__media {
  width: 135px;
  height: 135px;
  position: relative;

  button {
    position: absolute;
    right: 0px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>